define([
	"dojo/_base/declare",
	"csi/form/Widget",
	"csi/locale",
	"csi/store/_base",
	"csi/xml"
], function(declare,Widget,locale,csi_store,xml) {

	return declare(Widget, {
		resetForm: function() {
			// summary: when repeating new operation, make sure to add new node to store
			var	enumList = this.defView.getSourceNode();
			if (enumList) {
				var	f = this.defView.getField("DependsOn");
				var	s = (f && f.m_control) ? f.m_control.store : null;
				if (s) {
					s.put(csi_store.nameObject(enumList));
				}
			}

			this.inherited(arguments);
		}
	});
});